<template>
  <el-row>
    <!-- 顶头信息 -->
    <el-row v-show="false">
      <div class="top1" style="background-color: #FFF; border-bottom: solid 1px #E5E5E5;">
        <div class="top_1">
          <div class="top_1_1">
            <a class="changehands" @click="showWechatImg()" style="cursor:pointer;" >关注微信</a>
          </div>
          <div class="top_1_2">
            <ul id="sddm">
              <li style="float: right;"><a href="#">客服电话：029-68892595</a></li>
              <li style="float: right;"><a href="http://gsvweb.zft365.com/#/">管理登录</a></li>
            </ul>
          </div>
        </div>
      </div>
    </el-row>

    <el-row style="width:90%; margin:0 auto;">
      <!-- 登录区（暂时不用） -->
      <el-row v-show="false">
        <div class="top2">
          <div class="top2_1">
            <div class="logo">
              <table>
              <tr>
                <td>
                  <img :src="snnulogo" width="200px;" height="50px"/>
                </td>
                <td style="border-right:1px solid #CCC;">
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </td>
                <td>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </td>
                <td>
                  <img :src="UnionPayOnlinePayment" width="150" height="37"/>
                </td>
              </tr>
              </table>
              <a href="javascript:();"></a>
            </div>
            <div class="nav">

            </div>
          </div>
        </div>
        <!-- header is over -->
        <div class="content main">
          <div class="jf">
            <div class="dlck" style="float: left;">
              <h3 class="h3">
                    陕西师范大学
              </h3>
              <div>
              </div>
              <el-row style="margin-top: 14px">
                <el-form :model="global.curUser" ref="form" label-width="60px">
                  <el-form-item label="姓名">
                    <el-input v-model="global.curUser.userName" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="学号">
                    <el-input v-model="global.curUser.keyInfo" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                </el-form>
                
                <el-row style="width:100%;margin: 20px auto;"><el-button style="width: 100%" type="success" @click="query()">登录</el-button></el-row>
              </el-row>
            </div>
            <div style="width: 545px; height: 380px; float: right;">
              <!-- <div id="idContainer2" class="container" style="margin:8px 8px 0px 0px; background: #000; width: 590px; height: 370px;border:1px solid #CCC;" > -->
                <el-carousel indicator-position="outside">
                  <el-carousel-item>
                    <img :src="snnupic1" />
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
          
        </div>
        <br/>
        <div class="tybottom">
          <div class="hzhb">
            <table width="100%;" border="0" cellpadding="0" cellspacing="0">
            <tr style="line-height: 5px;">
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td width="250px;" valign="top">
                <h2>合作伙伴</h2>
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td valign="top">
                <h2>支持银行（200余家）</h2>
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <img :src="coopLogo" width="187" height="50" style="margin-bottom: 0px;" />
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                <el-row>
                  <el-col :span="1" v-for="item in imgListBank" :key="item.id">
                    <div>
                      <el-button type="text" @click="handleButtonCommand(item.redirectUrl)">
                        <img :src="item.url"/>
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            </table>
          </div>
          <div class="Copy">
              技术提供方　西安银杏软件有限公司　陕ICP备14001946号-2
            <br/>客服电话：4008786390
          </div>
        </div>
        <div id="loadimg" align="center" style="width:100%; height:100%; left:0px; top:0px; right:0px; bottom:0px; display:none; position:fixed; background-color:rgba(0,0,0,0.5); z-index:999999;">
            <div style="width:300px;height:330px;margin-top:100px;background: #FFF"  align="center">
              <div style="width: 100%;height: 10px;">
                <span onclick="closewximg()" style="font-size: 20px; font-weight:500; color: #000; cursor: pointer; float: right;color: red;">×&nbsp;&nbsp;</span>
                </div>
                <br/>
              <div align="center">
                    <img :src="qrcode" width="250px;" height="250px;"/><br/><br/>
              </div>
            </div>
        </div>
      </el-row>
      <!-- 登录区(PC端手机端通用) -->
      <el-row v-show="loginFormVisible">
        <div class="top2">
          <div class="top2_1">
            <div style="width:136px; height:38px; margin-top:17px; text-align:center;">
              <table>
              <tr>
                <td>
                  <img :src="snnulogo" width="200px;" height="50px"/>
                </td>
              </tr>
              </table>
            </div>
          </div>
        </div>
        <!-- header is over -->
        <div class="content">
          <div class="jf">
            <div style="height:280px; border:1px solid #CECECE; background:#F4F4F4; margin-top:8px; margin-left:8px; padding:15px; font-size:14px; font-weight:400; line-height:30px;">
              <h3 style="text-align:center; color:#FF0000; font-weight:600; font-size:20px; padding-top:20px;">
                    陕西师范大学
              </h3>
              <div>
              </div>
              <el-row style="margin-top: 14px">
                <el-form :model="global.curUser" ref="form" label-width="68px">
                  <el-form-item label="姓名">
                    <el-input v-model="global.curUser.userName" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="学号">
                    <el-input v-model="global.curUser.keyInfo" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                </el-form>
                
                <el-row style="width:100%;margin: 20px auto;"><el-button style="width: 100%" type="success" @click="query()">登录</el-button></el-row>
              </el-row>
            </div>
          </div>
          
        </div>
        <br/>
      </el-row>
      <!-- 标签 --> 
      <el-row v-show="menuVisible">
        <el-menu
          default-active="/MyBill"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/MyBill">我的账单</el-menu-item>
          <!-- <el-menu-item index="/MyBillHistory">已缴账单</el-menu-item> -->
        </el-menu>
        <br>
        <br>
      </el-row>
      <!-- 账单信息 -->
    <el-row v-show="feeListVisible">
      <el-form :model="viewForm" ref="viewForm" label-width="60px" style="background-color: #fff">
        <el-form-item label="学号" class="form-item">
          <span>{{ viewForm.stu_no }}</span>
        </el-form-item>
        <el-form-item label="姓名" class="form-item">
          <span>{{ viewForm.stu_name }}</span>
        </el-form-item>
        <el-form-item label="专业" class="form-item">
          <span>{{ viewForm.stu_zy }}</span>
        </el-form-item>
        <el-form-item label="班级"  class="form-item">
          <span>{{ viewForm.stu_bj }}</span>
        </el-form-item>
        <el-form-item label="总额"  class="form-item" v-if="getFeeDetailVisible()">
          <span>{{ Ginkgo.format(viewForm.sumamount, 'money') }}</span>
        </el-form-item>
        <el-form-item label="总额"  class="form-item" v-if="!getFeeDetailVisible()">
          <span>不欠费</span>
        </el-form-item>
        <el-collapse v-if="getFeeDetailVisible()">
          <el-collapse-item title="费用明细" name="1" style="width: 100%">
            <el-row>
              <!-- <div ><span class="label_detail">保险费</span><span class="label_value">100.00</span></div> -->
              <div v-if="viewForm.Item1 !== ''">
                <span class="label_detail">{{ viewForm.Item1 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount1, 'money') }}</span>
              </div>
              <div v-if="viewForm.item2 !== ''">
                <span class="label_detail">{{ viewForm.item2 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount2, 'money') }}</span>
              </div>
              <div v-if="viewForm.item3 !== ''">
                <span class="label_detail">{{ viewForm.item3 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount3, 'money') }}</span>
              </div>
              <div v-if="viewForm.item4 !== ''">
                <span class="label_detail">{{ viewForm.item4 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount4, 'money') }}</span>
              </div>
              <div v-if="viewForm.item5 !== ''">
                <span class="label_detail">{{ viewForm.item5 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount5, 'money') }}</span>
              </div>
              <div v-if="viewForm.item6 !== ''">
                <span class="label_detail">{{ viewForm.item6 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount6, 'money') }}</span>
              </div>
              <div v-if="viewForm.item7 !== ''">
                <span class="label_detail">{{ viewForm.item7 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount7, 'money') }}</span>
              </div>
              <div v-if="viewForm.item8 !== ''">
                <span class="label_detail">{{ viewForm.item8 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount8, 'money') }}</span>
              </div>
              <div v-if="viewForm.item9 !== ''">
                <span class="label_detail">{{ viewForm.item9 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount9, 'money') }}</span>
              </div>
              <div v-if="viewForm.item10 !== ''">
                <span class="label_detail">{{ viewForm.item10 }}</span><span class="label_value">{{ Ginkgo.format(viewForm.amount10, 'money') }}</span>
              </div>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-row style="text-align:center;padding:10px 0" v-if="getFeeDetailVisible()">
          <el-button style="width:100%" type="danger" :disabled="payButtonDisable" @click="toPay()" :loading="buttonLoad">去支付</el-button>
        </el-row>
      </el-form>
    </el-row>
      <!-- 支付按钮 -->
      <el-row v-show="payTypeVisible">
        <mt-header fixed>
          <div style="background:#5FCAC0;margin-top:25px;padding:10px 5px">
            <i class="el-icon-arrow-left" style="color:#FFF;"></i>
            <mt-button icon="back" slot="left" style="color:#FFF;" @click="back('03')">返回</mt-button
          ></div>
        </mt-header>
        <el-row style="margin-top: 30px;">
        <!-- <el-row> -->
          <el-row v-show="feePayType_WX" style="bottom:15px;">
            <!-- <mt-cell title="微信支付" v-on:click.native="doPay(payType)" value="使用微信支付，方便快捷" style="min-height: 65px;" is-link> -->
            <mt-cell v-on:click.native="doPay(payType)" style="min-height: 65px;" is-link class="wx" @click="doPay(payType)">
              <div class="wximg">
                <img slot="icon" :src="wx" width="50" height="45">
                微信支付
              </div>
              <div>使用微信支付，方便快捷<span class="el-icon-arrow-right"></span></div>
            </mt-cell>
            <!-- <el-button style="width:100%" type="success" @click="doPay(payType)">微信支付</el-button> -->
          </el-row>
          <el-row v-show="feePayType_UN">
          <!-- <el-row v-show="feePayType_UN"> -->
            <!-- <mt-cell title="银联支付" v-on:click.native="doPay(payTypeUnion)" value="使用银联支付，优惠多多" style="min-height: 65px;" is-link> -->
            <mt-cell title="银联支付" v-on:click.native="doPay(payTypeUnion)" style="min-height: 65px;" is-link class="yl" @click="doPay(payTypeUnion)">
              <div class="ylimg">
                <img slot="icon" :src="yl" width="50" height="45">
                银联支付
              </div>
              <div>使用银联支付，优惠多多<span class="el-icon-arrow-right"></span></div>
            </mt-cell>
            <!-- <el-button style="width:100%" type="primary" @click="doPay(payTypeUnion)">银联支付</el-button> -->
          </el-row>
        </el-row>
      </el-row>  
      <!-- 历史查询结果窗体 -->
      <el-row v-show="feeListHistoryVisible">
        <el-table ref="resultTable" :data="tableData"
          style="width: 100%; margin-top: 10px;" @sort-change="handleSortChangeHistory" highlight-current-row stripe border :height="global.tableHeight"
        >
          <el-table-column type="index" fixed width="60">
          </el-table-column>
          <!-- 数据列 -->
          <el-table-column
            v-for="item in getUISetQueryResult('01')" :key="item.columnName" :prop="item.columnProp" :label="item.columnDesc.split('|')[0]"
              :min-width="item.colWidth" :align="item.alignType" :formatter="dataFormatHistory"
              :fixed="Ginkgo.getColumnFixed(item)" sortable="custom" header-align="center"
            v-if="getHeaderVisible(item, 1)"
          >
            <el-table-column
              v-for="item2 in getHeaderGroup(item, 2, '01')" :key="item2.columnName" :prop="item2.columnProp" :label="item2.columnDesc.split('|')[1]"
                :min-width="item2.colWidth" :align="item2.alignType" :formatter="dataFormatHistory"
                :fixed="Ginkgo.getColumnFixed(item2)" sortable="custom" header-align="center"
              v-if="getHeaderVisible(item2, 2)"
            >
              <el-table-column
                v-for="item3 in getHeaderGroup(item2, 3, '01')" :key="item3.columnName" :prop="item3.columnProp" :label="item3.columnDesc.split('|')[2]"
                  :min-width="item3.colWidth" :align="item3.alignType" :formatter="dataFormatHistory"
                  :fixed="Ginkgo.getColumnFixed(item3)" sortable="custom" header-align="center"
                v-if="getHeaderVisible(item3, 3)"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChangeHistory" @current-change="handleCurrentChangeHistory"
          :current-page="page.number + 1" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalElements" :page-count="page.totalPages"
        >
        </el-pagination>
      </el-row>
      <!-- 关注微信 -->
      <el-row>
        <el-dialog :title="dialogFormTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-row style="text-align:center;padding:10px 0">
            <img :src="weixin" />
          </el-row>
        </el-dialog>
      </el-row>
      <!-- 支付二维码 -->
      <el-row>
        <el-dialog title="账单信息二维码" :visible.sync="qrcodeShow" :close-on-click-modal="false">
          <el-row style="text-align:center;padding:10px 0">
            <!-- <img :src="weixin" /> -->
              <vue-qr
                :text="payUrl"
                :size="150"
                :margin="0"
                :binarize="false"
                ref="qrcode"
                :autoColor="false"
              ></vue-qr>
          </el-row>
          <el-row style="text-align:left;padding:10px 0">
            <span ><span style="color: red;font-weight: bold;">注：</span>请使用微信扫一扫，确认账单之后进行缴款支付。支付成功之后，请重新进入系统。</span>
          </el-row>
        </el-dialog>
      </el-row>
     </el-row>
  </el-row>
</template>
<script>
import vueQr from 'vue-qr'
export default {
  name: 'MyBillShanShiDa',
  components: {
    vueQr
  },
  data: function () {
    return {
      weixin: this.global.staticResourceAddr + 'gsvvuepcoif/images/zft2Code.jpg',
      snnulogo: this.global.staticResourceAddr + 'gsvvuepcoif/images/shanshida/snnulogo.png',
      UnionPayOnlinePayment: this.global.staticResourceAddr + 'gsvvuepcoif/images/shanshida/UnionPayOnlinePayment.png',
      snnupic1: this.global.staticResourceAddr + 'gsvvuepcoif/images/shanshida/snnupic1.jpg',
      coopLogo: this.global.staticResourceAddr + 'gsvvuepcoif/images/bank/coopLogo.png',
      qrcode: this.global.staticResourceAddr + 'gsvvuepcoif/images/shanshida/qrcode_for_gh_638bf326c0ab_430.jpg',
      wx: this.global.staticResourceAddr + 'gsvvuemobileoif/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvvuemobileoif/' + this.global.theme + '/images/yl.png',
      modeSelectList: [],
      keyInfo: '',
      deptId: 0,
      unitCode: '212170060', // 单位号
      loginInfo: {
        userName: '',
        userNumber: ''
      },
      form: {},
      viewForm: {}, // login返回的对象
      responseObj: {}, // 接口返回来的对象
      // 控制属性
      feeListVisible: false,
      queryFormVisible: false,
      isAllTermPay: false,
      feeListHistoryVisible: false,
      tabSelected: 'default', // 默认显示本期账单
      tollRange: '', // 收费区间
      selectedRadio: '',
      menuVisible: false,
      payButtonDisable: false,
      loginFormVisible: false,

      // 标签图片
      homeImg: false,
      homeImgSelected: true,
      mineImgSelected: true,
      mineImg: false,

      pageStyle: '01',
      feeList: [],
      feeListHistory: [], // 历史缴费列表

      payRule: '',
      channelFlag: '01',
      merchantCode: '',
      detailViewTypeKd: '',
      multipleSelection: [],

      tableData: [],  // table绑定数据
      termList: [],
      buttonLoad: false,
      payTypeVisible: false,
      feePayType_WX: false,
      feePayType_UN: false,
      payType: '',
      payTypeUnion: '01',
      customerType: '', // 客户类型

      qrcodeShow: false, // 支付二维码可见性
      payUrl: '',

      // 查询窗体
      queryForm: {},
      uiSetItemList: [], // 原始
      uiSetList: [],
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),

      // ！！！初始排序对象
      sort: { prop: 'deptName', order: 'ascending' },
      imgListBank: [
        { id: 1, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh001.jpg', redirectUrl: '' },
        { id: 2, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh002.jpg', redirectUrl: '' },
        { id: 3, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh003.jpg', redirectUrl: '' },
        { id: 4, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh004.jpg', redirectUrl: '' },
        { id: 5, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh005.jpg', redirectUrl: '' },
        { id: 6, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh006.jpg', redirectUrl: '' },
        { id: 7, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh007.jpg', redirectUrl: '' },
        { id: 8, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh008.jpg', redirectUrl: '' },
        { id: 9, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh009.jpg', redirectUrl: '' },
        { id: 10, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh010.jpg', redirectUrl: '' },
        { id: 11, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh011.jpg', redirectUrl: '' },
        { id: 12, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh012.jpg', redirectUrl: '' },
        { id: 13, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh013.jpg', redirectUrl: '' },
        { id: 14, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh014.jpg', redirectUrl: '' },
        { id: 15, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh015.jpg', redirectUrl: '' },
        { id: 16, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh016.jpg', redirectUrl: '' },
        { id: 17, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh017.jpg', redirectUrl: '' },
        { id: 18, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh018.jpg', redirectUrl: '' },
        { id: 19, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh019.jpg', redirectUrl: '' },
        { id: 20, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh020.jpg', redirectUrl: '' },
        { id: 21, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh021.jpg', redirectUrl: '' },
        { id: 22, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh022.jpg', redirectUrl: '' },
        { id: 23, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh023.jpg', redirectUrl: '' },
        { id: 24, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh024.jpg', redirectUrl: '' },
        { id: 25, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh025.jpg', redirectUrl: '' }
      ]
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      var self = this
      // self.$indicator.open()
      // let uiSetIdList = 'vi_Customer_Merchant_Mobile,tbPm_Fee_Kd_PayFeeOut,tbPm_Fee_Kd_PayFee_Item,tbPm_Fee_Prop_PayFeeOut,tbPm_Fee_Prop_Item,tbSy_User_Bind_01,tbSy_User_Bind_02,tbSy_User_Bind_03,tbSy_User_Bind_04,tbSy_User_Bind_05,tbSy_User_Bind_06'
      self.getMode()
      self.getUISet()
      self.resetForm()
      this.initQueryForm()
      console.log('页面里：', this.global.loginType)
      if (this.global.loginType === '01') {
        this.setVisible('01')
      } else {
        this.query()
      }
    } else {
      this.setVisible('01')
    }
  },
  watch: {
  },
  methods: {
    setVisible: function (showType) {
      console.log('进来啦。。。。。', showType)
      if (showType === '01') { // 登录显示
        this.loginFormVisible = true
        this.feeListVisible = false
        this.menuVisible = false
        this.feeListHistoryVisible = false
        this.payTypeVisible = false
      }
      if (showType === '02') { // 楼号显示
        this.loginFormVisible = false
        this.feeListVisible = false
        this.feeListHistoryVisible = false
        this.menuVisible = true
        this.payTypeVisible = false
      }
      if (showType === '03') { // 费用信息
        this.loginFormVisible = false
        this.feeListVisible = true
        this.feeListHistoryVisible = false
        this.menuVisible = true
        this.payTypeVisible = false
      }
      if (showType === '04') { // 缴费历史
        this.loginFormVisible = false
        this.feeListVisible = false
        this.feeListHistoryVisible = true
        this.menuVisible = true
        this.payTypeVisible = false
      }
      if (showType === '05') { // 支付按钮
        this.queryFormVisible = false
        this.feeListVisible = false
        this.payTypeVisible = true
        this.menuVisible = false
        this.feeListHistoryVisible = false
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    getFeeDetailVisible: function () {
      let visible = true
      visible = visible && this.viewForm.Retcode === '00'
      return visible
    },
    // 多选响应
    handleSelectionChange: function(val) {
      this.multipleSelection = val
    },
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
    },
    // 加载界面配置
    getUISet: function () {
      var self = this
      self.uiSetItemList = self.global.uiSetItemList
      self.uiSetList = self.global.uiSetList
    },
    // 重置编辑窗体
    resetForm: function () {
      this.loginInfo = {
        userName: '',
        userNumber: ''
      }
      this.tollRange = ''
      this.global.curUser.deptId = ''
      // this.setVisible('01')
    },
    getDeptId: function (unitCodeSub) {
      let data = this.modeSelector('Dept_Map_lvYuan').filter(item => item.modeValue === unitCodeSub)
      this.global.curUser.deptId = data[0].modeId
    },
    // 学号
    query: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        if (self.global.curUser.keyInfo.trim() === '' || self.global.curUser.userName.trim() === '') {
          self.$alert('学号和姓名不能为空！')
        } else {
          localStorage.userName = this.global.curUser.userName.trim()
          localStorage.keyInfo = this.global.curUser.keyInfo.trim()

          self.login()
        }
      }
    },
    // 查询登录(01)
    login: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        // 初始化
        self.selectedRadio = ''
        let request = {}
        request.idIf = 30
        request.deptId = this.global.deptId
        request.itemList = [
          {paramName: 'message_type', paramValue: '01'},
          {paramName: 'Trans_date', paramValue: this.Ginkgo.getTimeStamp(new Date()).substring(0, 8)},
          {paramName: 'Trans_time', paramValue: this.Ginkgo.getTimeStamp(new Date()).substr(8, 6)},
          {paramName: 'req_serial1', paramValue: this.Ginkgo.getTimeStamp(new Date()).substring(0, 6)},
          {paramName: 'req_serial2', paramValue: this.Ginkgo.getTimeStamp(new Date()).substring(0, 6)},
          {paramName: 'ans_serial1', paramValue: ''},
          {paramName: 'futures_area', paramValue: ''},
          {paramName: 'futures_id', paramValue: ''},
          {paramName: 'Bank_id', paramValue: ''},
          {paramName: 'branch_id', paramValue: ''},
          {paramName: 'operator_id', paramValue: ''},
          {paramName: 'stu_no', paramValue: this.global.curUser.keyInfo},
          {paramName: 'account_no', paramValue: ''},
          {paramName: 'stu_name', paramValue: this.global.curUser.userName},
          {paramName: 'stu_bm', paramValue: ''},
          {paramName: 'stu_zy', paramValue: ''},
          {paramName: 'stu_bj', paramValue: ''},
          {paramName: 'Sfqj', paramValue: this.tollRange},
          {paramName: 'Retcode', paramValue: ''},
          {paramName: 'Retmsg', paramValue: ''},
          {paramName: 'sum', paramValue: ''},
          {paramName: 'sumamount', paramValue: '0.0'},
          {paramName: 'Item1', paramValue: ''},
          {paramName: 'amount1', paramValue: '0.0'},
          {paramName: 'item2', paramValue: ''},
          {paramName: 'amount2', paramValue: '0.0'},
          {paramName: 'item3', paramValue: ''},
          {paramName: 'amount3', paramValue: '0.0'},
          {paramName: 'item4', paramValue: ''},
          {paramName: 'amount4', paramValue: '0.0'},
          {paramName: 'item5', paramValue: ''},
          {paramName: 'amount5', paramValue: '0.0'},
          {paramName: 'item6', paramValue: ''},
          {paramName: 'amount6', paramValue: '0.0'},
          {paramName: 'item7', paramValue: ''},
          {paramName: 'amount7', paramValue: '0.0'},
          {paramName: 'item8', paramValue: ''},
          {paramName: 'amount8', paramValue: '0.0'},
          {paramName: 'item9', paramValue: ''},
          {paramName: 'amount9', paramValue: '0.0'},
          {paramName: 'item10', paramValue: ''},
          {paramName: 'amount10', paramValue: '0.0'}
        ]
        console.log('输出参数：', request)
        this.axios.post('/iif/accessIfForHttp', request
        )
        .then(function (response) {
          console.log('login response', response.data)
          if (response.data.result.success === true) {
            let obj = response.data.responseObj
            if (obj.Retcode === '00' || obj.Retcode === '02') { // 成功
              self.viewForm = obj
              if (obj.Retcode === '02') {
                self.payButtonDisable = true
                self.$message({ type: 'success', message: '不欠费!' })
              }
              if (obj.stu_name === self.global.curUser.userName) {
                self.setVisible('03')
              } else {
                self.$alert('输入的信息不正确！')
              }
              // self.withhold()
              // self.washed()
            } else {
              self.$alert(obj.Retmsg)
            }
            // self.getDeptSet()
          } else {
            self.buttonLoad = false
            self.$alert(response.data.result.msg)
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        self.setVisible('03')
      }
    },
    // 生成订单
    createOrderInfo: function () {
      var self = this
      this.form = this.Ginkgo.resetForm(this.uiSetItemList, 'tbIf_Order_Info_Common')
      // 增加一条账单
      this.form.id = 0
      this.form.transDt = 0
      this.form.term = this.Ginkgo.getTimeStamp() // 收费期
      this.form.statusCode = '02' // 初始核准状态
      this.form.deptId = this.global.deptId
      this.form.keyInfo = this.global.curUser.keyInfo // 用户号
      this.form.feeNo = '缴费'
      this.form.feeAmount = this.viewForm.sumamount
      this.form.payableAmount = this.viewForm.sumamount
      this.form.idIf = 30
      this.form.field1 = this.viewForm.stu_name // 姓名
      this.form.field2 = '' // 预留，缴费期
      this.form.field3 = this.viewForm.stu_zy // 专业
      this.form.field4 = this.viewForm.stu_bj // 专业
      this.form.field5 = this.viewForm.stu_bm // 机构（部门）
      this.form.field6 = localStorage.fdzid || ''
      this.form.field7 = localStorage.majorcode || ''
      if (this.global.loginType === '01') {
        this.form.field8 = '03'
        this.form.field6 = ''
        this.form.field7 = ''
      } else {
        this.form.field8 = localStorage.studentType || ''
      }

      // 把10项费用拼接起来
      let feeInfo = ''
      feeInfo = feeInfo + this.viewForm.Item1 + '|' + this.viewForm.amount1 + '|'
      feeInfo = feeInfo + this.viewForm.item2 + '|' + this.viewForm.amount2 + '|'
      feeInfo = feeInfo + this.viewForm.item3 + '|' + this.viewForm.amount3 + '|'
      feeInfo = feeInfo + this.viewForm.item4 + '|' + this.viewForm.amount4 + '|'
      feeInfo = feeInfo + this.viewForm.item5 + '|' + this.viewForm.amount5 + '|'
      feeInfo = feeInfo + this.viewForm.item6 + '|' + this.viewForm.amount6 + '|'
      feeInfo = feeInfo + this.viewForm.item7 + '|' + this.viewForm.amount7 + '|'
      feeInfo = feeInfo + this.viewForm.item8 + '|' + this.viewForm.amount8 + '|'
      feeInfo = feeInfo + this.viewForm.item9 + '|' + this.viewForm.amount9 + '|'
      feeInfo = feeInfo + this.viewForm.item10 + '|' + this.viewForm.amount10 + '|'

      // 去掉最后一个分号
      feeInfo = feeInfo.substr(0, feeInfo.length - 1)

      this.form.remark = feeInfo

      console.log('self.form', self.form)
      this.axios.get('/iif/addOrderInfo', { params: this.form }
      )
      .then(function (response) {
        if (response.data.result.success === true) {
          console.log('createOrderInfo', response.data)
          // 处理账期列表，用于下面的doPay接口
          self.termList = []
          self.termList.push(self.form.term)
          // self.unionPay()
          self.getDeptSet()
        } else {
          self.$alert('生成账单失败！')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 获取机构支付配置
    getDeptSet: function () {
      var self = this
      self.axios.get('/public/getBaseDeptSetByDeptID', { params: {
        deptId: self.global.deptId
      }})
      .then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          let wxPayType = response.data.viDeptSetList.filter(item => item.payType === '02' || item.payType === '03' || item.payType === '98')
          if (wxPayType.length > 0) { // 有且仅有一个
            self.channelFlag = wxPayType[0].channelFlag
            self.merchantCode = wxPayType[0].merchantCode
          }
          self.setVisiblePayButton(response.data.viDeptSetList)
          self.setVisible('05')
        }
        self.buttonLoad = false
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
   // 获取历史缴费信息
    getHistory: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.get('/iif/getOrderInfoForHistory', { params: {
          deptId: self.global.deptId,
          keyInfo: self.global.curUser.keyInfo
        }})
        .then(function (response) {
          // 机构配置信息
          if (response.data.result.success === true) {
            self.orderInfoList = response.data.orderInfoList
            // 首次默认排序
            self.handleSortChangeHistory(self.sort)
            // 分页处理
            self.page.totalElements = self.orderInfoList.length
            self.loadCurrentPageHistory()
            // 设置当前选中行
            self.setCurrentRowHistory()
            self.setVisible('04')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.orderInfoList = [
          {transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx'}
        ]
        this.setVisible('04')
      }
    },
    // 点击去支付按钮
    toPay: function () {
      // var self = this
      // if (self._isMobile()) {
      //   console.log('手机端')
      //   self.checkPayTime()
      // } else {
      //   console.log('PC端')
      //   self.createQrcode()
      // }
      this.checkPayTime()
    },
    createQrcode: function () {
      var self = this
      // this.$alert('因系统升级维护,PC端缴费功能暂停使用。请通过关注【陕师大网络教育教学支持服务】微信公众号，在“学生平台”菜单进行缴费！')
      self.payUrl = ''
      let payPath = 'http://snnu.zft365.com/#/?type=05&deptId=1007474'
      console.log('stu_name>>>' + localStorage.userName)
      console.log('stu_no>>>' + localStorage.keyInfo)
      console.log('fdzid>>>' + localStorage.fdzid)
      console.log('majorcode>>>' + localStorage.majorcode)
      if (localStorage.userName) {
        payPath = payPath + '&stu_name=' + localStorage.userName
      }
      if (localStorage.keyInfo) {
        payPath = payPath + '&stu_no=' + localStorage.keyInfo
      }
      if (localStorage.fdzid) {
        payPath = payPath + '&fdzid=' + localStorage.fdzid
      }
      if (localStorage.majorcode) {
        payPath = payPath + '&majorcode=' + localStorage.majorcode
      }
      self.payUrl = payPath
      self.qrcodeShow = true
      console.log('this.payUrl', self.payUrl)
    },
    checkPayTime: function () {
      var self = this
      self.axios.get('/public/checkToPay', { params: {
        deptId: self.global.deptId // 1000003
      }})
      .then(function (response) {
        if (response.data.result.success === true) {
          self.createOrderInfo() // 成功生成订单
        } else {
          self.$alert(response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    back: function (type) {
      this.setVisible(type)
    },
    doPay: function (payType) {
      var self = this

      let payUrl = ''

      if ((!self._isMobile()) && (payType === '02' || payType === '03' || payType === '98')) {
        console.log('pc端 且微信支付')
        self.createQrcode()
        return
      }

      // 根据不同支付方式访问不同的发起交易服务
      self.axios.post('/public/toPay', {
        keyInfo: self.global.curUser.keyInfo,
        deptId: self.global.deptId,
        payType: payType,
        feeTermList: self.termList,
        validType: '01'
      })
      .then(function (response) {
        if (response.data.result.success) {
          if (payType === '02' || payType === '03' || payType === '98') { // 微信支付
            if (self.channelFlag === '02') {
              payUrl = self.global.wechatAuthUrl + '?state=' + self.merchantCode + ';payType:' + payType + ';orderNo:' + response.data.orderNo + ';deptId:' + response.data.deptId + ';payChannel:01'
            } else {
              payUrl = self.global.wechatAuthUrl + '?state=99999;payType:' + payType + ';orderNo:' + response.data.orderNo + ';deptId:' + response.data.deptId + ';payChannel:01'
            }
          } else { // 其他
            // self.createQrcode()
            // this.$alert('因系统升级维护,PC端缴费功能暂停使用。请通过关注【陕师大网络教育教学支持服务】微信公众号，在“学生平台”菜单进行缴费！')
            payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + payType + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02'
          }
          window.location.href = payUrl
        } else {
          self.$alert(response.data.result.msg)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    unionPay: function () {
      var self = this
      console.log('银联支付')
      self.axios.post('/pay/toPay', {
        keyInfo: self.global.curUser.keyInfo,
        deptId: self.global.deptId,
        payType: self.payTypeUnion,
        feeTermList: self.termList,
        channelType: '02',
        validType: '01'
      })
      .then(function (response) {
        if (response.data.result.success) {
          self.buttonLoad = false
          var wechatUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02'
          window.location.href = wechatUrl
        } else {
          self.$message({ type: 'success', message: response.data.result.msg })
        }
      })
      .catch(function (error) {
        self.buttonLoad = false
        console.log(error)
      })
    },

    // 初始化查询条件窗体
    initQueryForm: function () {
      this.form = this.Ginkgo.resetForm(this.uiSetItemList, 'tbIf_Order_Info_MyBillShanShiDa')
      // 初始化排序
      this.sortSet = this.Ginkgo.getDefaultSort(this.getUISetCommon('01'))
      this.sort = this.sortSet[this.sortSet.length - 1]
    },

    setVisiblePayButton: function (deptSetList) {
      var self = this
      self.feePayType_UN = false
      self.feePayType_WX = false
      // 机构配置信息
      if (deptSetList.length > 0) {
        self.payRule = deptSetList[0].payRule
        if (self.payRule === '03') {
          self.isAllTermPay = true
        } else {
          self.isAllTermPay = false
        }
        deptSetList.forEach(function (e) {
          if (e.payType === '01' || e.payType === '14') {
            self.payTypeUnion = e.payType
            self.feePayType_UN = true
          } else if (e.payType === '02' || e.payType === '03' || e.payType === '99') {
            self.payType = e.payType
            self.feePayType_WX = true
          }
        })
      }
    },
    loadCurrentPage: function () {
      this.feeData = this.feeList
    },
    // 列数据格式化
    dataFormat: function (row, column, cellValue) {
      return this.Ginkgo.format(row.分类标准, 'money')
    },

    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function (val) {
      this.sort = val
      let sorts = this.Ginkgo.cloneObj(this.sortSet)
      sorts.pop() // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val)
      this.orderInfoList = this.Ginkgo.sort(this.orderInfoList, sorts)
      this.loadCurrentPage()
    },
    // 选中当前行
    setCurrentRowHistory: function () {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex])
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function () {
      this.tableData = this.orderInfoList.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size)
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function (val) {
      this.page.size = val
      this.loadCurrentPageHistory()
    },
    // 页码改变事件
    handleCurrentChangeHistory: function (val) {
      this.page.number = val - 1
      this.loadCurrentPageHistory()
    },
    // 获取查询结果配置
    getUISetQueryResult: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_MyBillShanShiDa' : 'tbExp_Student_Item'
      let sort = {prop: 'sortNoResult', order: 'ascending'}

      let list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1'
      })

      return this.Ginkgo.sortList(list, sort)
    },
    // 获取查询结果配置
    getUISetCommon: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_MyBillShanShiDa' : 'tbExp_Student_Item'

      let listUi = this.uiSetList.filter(function (element) {
        return element.uiSetId === setId
      })

      return listUi[0]
    },
    // 列数据格式化
    dataFormatHistory: function (row, column, cellValue) {
      var columnProp = column.property
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp
      })[0].formatString

      return this.Ginkgo.format(cellValue, formatString)
    },
    // 获取同组记录
    getHeaderGroup: function (item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form))
    },
    // 列可见性
    getHeaderVisible: function (item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed)
    },
    // 操作列可见性
    getOpVisible: function (form) {
      return this.Ginkgo.getOpVisible(this.getUISetQueryResult(form))
    },
    handleSelect: function (index, indexPath) {
      if (process.env.NODE_ENV === 'production') {
        if (index === '/MyBill') {
          this.login()
        } else {
          this.getHistory()
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('01')
        } else {
          this.setVisible('01')
        }
      }
    },
    showWechatImg: function () {
      this.dialogFormVisible = true
    },
    handleButtonCommand: function (url) {
      window.location.href = url
    }
  }
}
</script>
<style>
.top1{width:auto; height:25px; background:#F4F4F4; padding-top:5px;}
.top_1{width:965px; height:17px; margin:0px auto; font-size:12px; padding-left:15px;}
.top_1_1{width:490px; float:left}
.top_1_1 a{ color:#666; text-decoration:none; }
.top_1_1 a:hover{ color:#000; text-decoration:underline }

.top_1_2 {width:330px; height:auto; float:right; margin-right:10px;}
/************下拉开始*************/
#sddm
{	margin: 0 auto;
	padding: 0;
	z-index: 30;
	width:330px;
	height:auto;}

#sddm li
{	margin:0px;
	padding:0 12px;
	list-style: none;
	float: left;
	width:auto;
}

#sddm li a
{	display: block;
	width:auto;
	color:#666;
	text-align: center;
	text-decoration: none}

#sddm li a:hover
{	 color:#000; text-decoration:underline}

#sddm div
{	position: absolute;
	visibility: hidden;
	margin: 0;
	padding: 0;
	background: #EAEBD8;
	border: 1px solid #5970B2}

	#sddm div a
	{	position: relative;
		display: block;
		margin: 0;
		padding: 5px 10px;
		width: auto;
		white-space: nowrap;
		text-align: left;
		text-decoration: none;
		background: #EAEBD8;
		color: #2875DE;
		font: 12px arial}

	#sddm div a:hover
	{	background: #49A3FF;
    color: #FFF
  }
  .top2{width:auto; height:72px;}
  .top2_1{width:980px;  height:auto; margin:0px auto}
  .logo{width:136px; height:38px; float:left; margin-top:17px;}
	.nav{width:445px; height:auto; float:right; margin-top:25px;}
  .nav ul{ margin:0px; padding:0px;}
  .nav ul li{ width:auto; height:auto; list-style-type:none; float:left; margin:0px 22px; text-align:center;}
  .nav a{ font-size:16px; color:#003399; text-decoration:none; font-weight:bold}
  .nav a:hover{font-size:16px; color:#000; text-decoration:underline; font-weight:normal}


  /************banner开始****************/
  .bannerbox{width:auto; height:385px;}


  /************banner结束****************/

  /*************第二部分开始*****************/

  .box2{width:998px; height:258px; margin:25px auto;}
  .jfbox{width:700px; height:125px; float:left;}
  .jfbox ul{margin:0px; padding:0px;}
  .jfbox ul li{width:96px; height:125px; float:left; text-align:center; margin-left:22px;}
  .jfbox ul li img{width:96px; height:90px; border:none;}
  .jfbox ul li a{ color:#003399; font-size:14px; text-decoration:none; font-weight:bold}
  .jfbox ul li a:hover{ color:#333}

  .xwdt{width:260px; height:100px; float:left; border-left:1px solid #CCC; padding-left:20px}
  .menub1_1{ font-size:14px; font-weight:bold; width:46px; text-align:center;}
  .menub1_1 a{color:#F00; text-decoration:none;}
  .menub1_1 a:hover{color:#666; text-decoration:none;}
  .menub1_2{ font-size:14px; font-weight:bold; width:46px; text-align:center;}
  .menub1_2 a{color:#F00; text-decoration:none}
  .menub1_2 a:hover{color:#666; text-decoration:none;}
  .menub1_3{ font-size:14px; font-weight:bold; width:46px; text-align:center}
  .menub1_3 a{color:#F00; text-decoration:none}
  .menub1_3 a:hover{color:#666; text-decoration:none;}

  .menugtab ul{ margin:0px; padding:0px;}
  .menugtab span{ margin:0px; padding:0px;float:right; width:auto; padding-right:10px;}
  .menugtab ul li{ width:268px; height:auto; font-size:12px;color:#666; margin-top:7px}
  .menugtab ul li a{ font-size:12px; color:#333; text-decoration:none}
  .menugtab ul li a:hover{ font-size:12px; color:#666; text-decoration:none}
  .cl1{ clear:both; width:auto; height:10px; border-bottom:1px solid #CCC; margin-bottom:5px}
  .content{ margin-top:15px;}

  /* .content .login{ background:url(../images/login_head.png) top left no-repeat; width:212px; float:right; padding-top:37px;} */
  .content .login div{ border:1px solid #EAEAEA; border-top:none; width:208px; height:175px;margin-left:1px; padding:15px 0;}
  .content .login .txt{ width:125px; border:1px solid #D0D0D0; height:25px;}


  .content .login table{ width:200px; height:170px; margin-left:10px;}
  .content .banner{ float:left; width:520px; height:239px; border:1px solid #CCCBCB; padding:1px; margin-left:10px;}
  .content .banner img{ width:520px; height:239px;}

  .content .tzgg{ width:236px; height:238px; float:left; padding-top:7px; padding-left:6px;border:1px solid #D4D4D2;}
  .content .tzgg .top_one{height:100px; padding-right:5px;}
  .content .tzgg .top_one img{ width:109px; height:86px; border:1px solid #D4D4D2; padding:1px; margin-right:5px; float:left;}
  .content .tzgg .top_one .title{ color:#FF0000; line-height:27px;}
  .content .tzgg .top_one .detail{ color:#FF0000; }

  .content .tzgg .list { margin-top:10px; margin-left:5px;}
  .content .tzgg .list li{ padding-left:0px;  line-height:25px; height:25px;}
  .content .tzgg .list li img{ margin-bottom:3px; margin: 2px,2px,2px,2px;}

  .content .program{ margin-top:15px;}
  .content .program a{ display:block; width:143px; height:132px; float:left; border:1px solid #DDDDDD; margin-right:25px;}
  .content .program img{ width:143px; height:132px; }

  .content .other{ margin-top:15px;}
  .content .other a{ display:block; width:303px; height:107px; float:left; border:1px solid #DDDDDD; margin-right:18px; background:#F9F9F9; padding:8px;}

  .footer{ height:120px; margin-top:15px; text-align:center;}
  .footer .copyright{ margin:10px auto; font-size:14px;}
  .footer .bs a{ margin:0 5px;}


  /*登陆页*/

  .content .h2{ text-align:center; color:#003B93; font-weight:600; font-size:25px; margin-top:40px; margin-bottom:35px;}

  .content .jf{ height:330px; border:1px solid #E9E9E9; padding:1px;}

  .content .jf .dlck{ width:350px; height:280px; border:1px solid #CECECE; background:#F4F4F4; margin-top:8px; margin-left:8px; padding:15px; font-size:14px; font-weight:400; line-height:30px;}
  .content .jf .dlck .h3{text-align:center; color:#FF0000; font-weight:600; font-size:20px; padding-top:20px;}

  .content .jf .dlck .ts{ height:55px; border-bottom:1px dashed #666666; text-align:center; margin-top:15px;}
  .content .jf .dlck p{ text-align:center;}

  .content .jf .dlck dl{ margin-top:20px;}
  .content .jf .dlck .dd{ width:345px; height:30px; margin-bottom:18px;}
  .Copy{width:510px; height:50px; margin:0px auto; font-size:12px; color:#999; text-align:center; line-height:200%; margin-top:120px;}
  /*********通用bottom************/
  .tybottom{width:auto; height:236px; margin-top:10px}
  .hzhb{width:950px; height:82px; margin:0px auto;}
  .hzhb h2{font-size:14px; color:#7F7F7F; padding-top:20px;}
  .hzhb ul{margin:0px; padding:0px;}
  .hzhb ul li{width:20px; height:20px; float:left; margin:5px 9px}
  .main{ width:1000px;margin:0 auto;}
  .form-item {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    /* margin-bottom: 2px; */
    margin-left: 5px;
  }
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    margin-left: 5px;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
    line-height: 40px !important;
  }
  .label_detail {
    margin: 0px 0px 0px 20px;
  }
  .label_value {
    margin: 0px 30px 0px 0px;
    float: right;
    /* width: 40% */
  }
  /* .el-radio__label {
    font-size: 12px !important;
    padding-left: 10px;
  } */
  /* 支付 */
  .wx,
  .yl {
    background: #fff;
    padding: 0 20px;
  }
  .wx,
  .yl,
  .ylimg,
  .wximg {
    display: flex;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    align-items: center;
    justify-content: space-between;
  }
  @media screen and (min-width: 400px) {
    .yl,
    .wx {
      font-size: 16px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 400px) {
    .yl,
    .wx {
      font-size: 14px;
    }
  }
  @media screen and (min-width: 260px) and (max-width: 320px) {
    .yl,
    .wx {
      font-size: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// MyBillShanShiDa.vue?9a2fae7c